import equals from 'fast-deep-equal';

export default equals as <T>(a: T, b: T) => boolean;
